import { MouseEvent } from 'react'
import { RxCross2 } from 'react-icons/rx'
import { Button } from '~/@/components/ui/button'
import { cn } from '~/@/lib/utils'
import { Table } from '~/common/generated/apollo-operations'
import { useLookupContext } from './hooks/LookupProvider'

interface LookupDialogHeaderProps {
  lookupTable?: Pick<Table, 'id' | 'name'> & { parentTable?: { id: string } | null }
  loading?: boolean
  handleNavigate: (event: MouseEvent<HTMLElement>) => void
  handleClose: () => void
}

/**
 * Displays the header of the lookup dialog
 */
export function LookupDialogHeader({
  lookupTable,
  handleNavigate,
  handleClose,
}: LookupDialogHeaderProps) {
  const { isUnauth } = useLookupContext()

  if (!lookupTable) {
    return null
  }

  return (
    <div className="flex w-full justify-between" id="draggable-lookup">
      <div
        className={cn(
          'text-gray-12 text-sm flex items-center gap-2 hover:underline',
          !isUnauth ? 'group/lookup hover:cursor-pointer' : 'pointer-events-none',
        )}
        onClick={handleNavigate}
      >
        {lookupTable.name}
      </div>
      <Button className="h-8 w-4" onClick={handleClose} size="icon" type="button" variant="ghost">
        <RxCross2 className="size-4" />
      </Button>
    </div>
  )
}
